module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {

	fox.registerWidget('Layout_Catalog', {

		configure: function(options) {
			this.sidebarIsVisible = false;

			this.registerOptions('', {
				pageContainer: '.models-sitepage-wrapper',
				widgets: {
					scrollHandler: {
						widget: 'WindowScrollHandler',
						bottomOffset: $(window).height(),
						customEnabling: true
					},
					closestLiveshows: {
						widget: 'Models_ClosestLiveshows'
					},
					header: {
						widget: 'Widget',
						autoRender: true,
						container: '.models-header',
						template: 'catalog_header',
						handleDom: {
							showSidebar: {
								target: '.menu-icon',
								event: 'click',
								callback: '@parent:_showSidebar'
							}
						},

						widgets: {
							sidebar: {
								widget: 'Menu_Sidebar',
								'widgets.menu.hooks.onAddedToDom': fox.bind(function (argument) {
									this.naviElm = this.wom1('#header #sidebar #menu').element[0];
								}, this)
							}
						}
					}
				},

				handleWom: {
					scrolling: {
						widget: '#scrollHandler',
						event: 'scrolling',
						callback: '_handleScrolling'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		addedToDom: function (argument) {
			this.headerElm = this.dom1('#models-header');
		},

		running: function (argument) {
			fox.dom.on('click', window, fox.bind(function () {
				this.hideSidebar();
			}, this));

			this.callParent('running', arguments);
		},

		_showSidebar: function (el, alias, w, e) {
			fox.dom.event.stop(e);
			this.showSidebar();
		},

		showSidebar: function () {
			if (this.sidebarIsVisible) {
				return;
			}

			fox.dom.addClass('active', this.wom1('#header').dom1('.menu-icon'));
			this.sidebarIsVisible = true;
		},

		hideSidebar: function () {
			if (!this.sidebarIsVisible) {
				return;
			}

			fox.dom.removeClass('active', this.wom1('#header').dom1('.menu-icon'));
			this.sidebarIsVisible = false;
		},

		_handleScrolling: function (offset) {
			var lshowHeight = 107;
			var t = offset.top;

			if (t >= lshowHeight && !this.freeze) {
				this.freeze = true;
				//this.naviElm.style.top = 112 + 'px';
				fox.dom.addClass('slide', this.headerElm);
			}

			if (t < lshowHeight) {
				this.freeze = false;
				//this.naviElm.style.top = (lshowHeight - t) + 'px';
				fox.dom.removeClass('slide', this.headerElm);
			}
		}

	}, 'Site_Layout');
	
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/layout/catalog.js
// module id = 128
// module chunks = 0